// extracted by mini-css-extract-plugin
export default {"slim":"QkWzv"};